<h2 [attr.data-count]="(items$ | async)?.length || 0" class="headingS">
  {{
    (items$ | async)?.length || 0
      | messageformat: [resultatenTitel, resultatenReplacementString]
  }}
</h2>
